/**
 * Query key factory for file-related queries.
 */
export const queryKeysFile = {
  base: () => 'files' as const,
  get: (fileLink: string) =>
    [queryKeysFile.base(), 'detail', { fileLink }] as const,
} as const;
